import { Navigate, Outlet } from "react-router-dom";


import UserNavbar from "../components/header/UserNavbar";
import { Footer } from "../components/footer/Footer";



export function UserPrivateLayout() {
  const userCode = localStorage.getItem("user_code");

  
 

  const profile = userCode
    ? {
        name: localStorage.getItem("user_name") || "User",
        userCode,
      }
    : null;

  if (!userCode) {
    return <Navigate to="/user-login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <UserNavbar profile={profile} />

      <main className="flex-grow">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}